import { render, staticRenderFns } from "./ProducerMarginalityComponent.vue?vue&type=template&id=02b739a6&scoped=true"
import script from "./ProducerMarginalityComponent.vue?vue&type=script&lang=js"
export * from "./ProducerMarginalityComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b739a6",
  null
  
)

export default component.exports